// Fixed UTC offsets rather than IANA zones — a scheduled subscription only
// cares about "deliver at 7:00 at this offset", not about the user's civic
// timezone's DST rules. This keeps the picker short, deterministic, and
// trivially serialisable on the backend (just store the offset string).
export const DefaultTimezone = "UTC+10:00";

const wholeHours = [
	-12, -11, -10, -9, -8, -7, -6, -5, -4, -3, -2, -1,
	0,
	1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14,
];

const pad = (n) => String(Math.abs(n)).padStart(2, "0");

const buildOffset = (hours, minutes = 0) => {
	if (hours === 0 && minutes === 0) return "UTC";
	const sign = hours < 0 ? "-" : "+";
	return `UTC${sign}${pad(hours)}:${pad(minutes)}`;
};

const halfHourOffsets = [
	{ hours: 5, minutes: 30 },   // India
	{ hours: 9, minutes: 30 },   // Adelaide, Darwin
	{ hours: 10, minutes: 30 },  // Lord Howe Island
];

const options = [
	...wholeHours.map((h) => ({ hours: h, minutes: 0 })),
	...halfHourOffsets,
].sort((a, b) => a.hours * 60 + a.minutes - (b.hours * 60 + b.minutes));

export const TimezoneOptions = options.map(({ hours, minutes }) => {
	const value = buildOffset(hours, minutes);
	return { value, label: value };
});
